export default __webpack_public_path__ + "af21313ce2c23eb0755cb02832140f88.svg";